import { render } from "./StatsLayout.vue?vue&type=template&id=518b66db"
import script from "./StatsLayout.vue?vue&type=script&lang=js"
export * from "./StatsLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__